module.exports = __webpack_public_path__ + "static/sara-lg-3b349138c433cf221c43466dec69b0ea.png";